<button
  [class.active]="isActive"
  (click)="handleClick($event)"
  [disabled]="isDisabled"
  [ngClass]="{ disabled: isDisabled }"
>
  <i>
    <ng-content></ng-content>
  </i>
  {{ titleButton }}
</button>
